import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme) => ({
  body: {
    marginTop: -64,
    minHeight: "100vh",
    position: "relative",
    padding: "20px",
    [theme.breakpoints.down("md")]: {
      padding: "16px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "16px",
    },
  },
  mainContainer: {
    height: "100%",
    padding: "64px 160px",
    display: "flex",
    gap: "40px",
    alignItems: "flex-start",
    [theme.breakpoints.down("lg")]: {
      padding: "64px 80px",
    },
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      gap: "20px",
      padding: "20px 0",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "10px 0",
      gap: "15px",
    },
  },
  contentArea: {
    flexGrow: 1,
    minHeight: "600px",
    [theme.breakpoints.down("md")]: {
      minHeight: "400px",
      width: "100%",
    },
    [theme.breakpoints.down("sm")]: {
      minHeight: "300px",
      width: "100%",
    },
  },
  messageList: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    [theme.breakpoints.down("sm")]: {
      gap: "12px",
    },
  },
  messageItem: {
    display: "flex",
    alignItems: "center",
    padding: "16px",
    backgroundColor: theme.design.color.border.default,
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: theme.design.color.border.popover,
    },
    [theme.breakpoints.down("sm")]: {
      padding: "12px",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "8px",
    },
  },
  messageIcon: {
    width: "20px",
    height: "20px",
    [theme.breakpoints.down("sm")]: {
      width: "16px",
      height: "16px",
    },
  },
  messageContent: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  messageTitle: {
    color: theme.design.color.text.primary,
    fontSize: "14px",
    fontWeight: 600,
    fontFamily: theme.design.typography.fontFamily,
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
    },
  },
  messageFrom: {
    color: theme.design.color.status.info,
    fontSize: "13px",
    fontFamily: theme.design.typography.fontFamily,
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  messageStatus: {
    fontSize: "12px",
    fontFamily: theme.design.typography.fontFamily,
    padding: "4px 8px",
    borderRadius: "4px",
    fontWeight: 600,
    [theme.breakpoints.down("sm")]: {
      fontSize: "11px",
      padding: "2px 6px",
    },
  },
  messageDate: {
    color: theme.design.color.text.muted,
    fontSize: "13px",
    fontFamily: theme.design.typography.fontFamily,
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  statusUnread: {
    backgroundColor: theme.design.color.status.warning,
    color: theme.design.color.text.primary,
  },
  statusRead: {
    backgroundColor: theme.design.color.status.success,
    color: theme.design.color.text.primary,
  },
  messageCheckbox: {
    color: theme.design.color.text.primary,
    backgroundColor: theme.design.color.surface.raised,
    borderRadius: "4px",
    padding: 0,
    width: "24px",
    height: "24px",
    border: `1px solid ${theme.design.color.surface.raised}`,

    "&.Mui-checked": {
      backgroundColor: theme.design.color.status.success,
      border: `1px solid ${theme.design.color.status.success}`,
      "& svg": {
        color: `${theme.design.color.border.default}!important`
      },
      "&:hover": {
        backgroundColor: theme.design.color.action.primaryHover,
        borderColor: theme.design.color.action.primaryHover,
      },
    },

    "&:hover": {
      backgroundColor: theme.design.color.border.default,
      borderColor: theme.design.color.border.default,
      "& svg": {
        color: `${theme.design.color.border.default}!important`
      }
    },

    "& .MuiSvgIcon-root, & .MuiSelect-icon, & svg": {
      fontSize: "12px",
      color: theme.design.color.text.primary,
    },

    "& svg": {
      width: 24,
      height: 24,
      color: `${theme.design.color.surface.raised} !important`,
    },
    [theme.breakpoints.down("sm")]: {
      width: "20px",
      height: "20px",
      "& svg": {
        width: 20,
        height: 20,
      }
    },
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
    position: "relative",
    [theme.breakpoints.down("md")]: {
      marginBottom: "16px",
      flexWrap: "wrap",
      gap: "10px",
    },
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
      gap: "12px",
    },
  },
  headerTitle: {
    color: theme.design.color.text.primary,
    fontSize: "24px",
    fontWeight: 600,
    fontFamily: theme.design.typography.fontFamily,
    [theme.breakpoints.down("md")]: {
      fontSize: "20px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
    },
  },
  deleteButton: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    cursor: "pointer",
    padding: "4px 8px",
    borderRadius: "6px",
    transition: "all 0.2s ease",
    color: theme.design.color.status.danger,

    "&:hover": {
      backgroundColor: theme.design.color.overlay.white10,
    },

    "& p": {
      fontSize: "16px",
      fontFamily: theme.design.typography.fontFamily,
      color: theme.design.color.status.danger,
    },
    [theme.breakpoints.down("sm")]: {
      padding: "6px 12px",
      minHeight: "44px", // Touch-friendly
      "& p": {
        fontSize: "14px",
      }
    },
  },
  deleteIcon: {
    fontSize: "20px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
    },
  },
  messageDetail: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    backgroundColor: theme.design.color.surface.popover,
    borderRadius: "12px",
    padding: "24px",
    [theme.breakpoints.down("md")]: {
      padding: "20px",
      gap: "16px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "16px",
      gap: "12px",
      borderRadius: "8px",
    },
  },
  messageDetailHeader: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    paddingBottom: "16px",
    [theme.breakpoints.down("sm")]: {
      gap: "6px",
      paddingBottom: "12px",
    },
  },
  messageDetailLabel: {
    color: theme.design.color.text.muted,
    fontSize: "18px",
    fontFamily: theme.design.typography.fontFamily,
    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  messageDetailValue: {
    color: theme.design.color.text.primary,
    fontSize: "18px",
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 500,
    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  messageDetailFrom: {
    color: theme.design.color.status.info,
    fontSize: "18px",
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 500,
    textDecoration: "underline",
    cursor: "pointer",
    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  messageBody: {
    backgroundColor: theme.design.color.border.default,
    padding: "20px",
    borderRadius: "8px",
    minHeight: "200px",
    color: theme.design.color.text.primary,
    fontSize: "14px",
    fontFamily: theme.design.typography.fontFamily,
    lineHeight: 1.6,
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    [theme.breakpoints.down("md")]: {
      padding: "16px",
      minHeight: "150px",
      fontSize: "13px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "12px",
      minHeight: "120px",
      fontSize: "12px",
    },
  },
  replyButton: {
    backgroundColor: theme.design.color.status.success,
    color: theme.design.color.text.primary,
    padding: "12px 24px",
    borderRadius: "8px",
    border: "none",
    cursor: "pointer",
    fontSize: "14px",
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 600,
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: theme.design.color.action.primaryHover,
    },
    [theme.breakpoints.down("sm")]: {
      padding: "10px 20px",
      fontSize: "13px",
      width: "100%",
      minHeight: "44px", // Touch-friendly
    },
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    backgroundColor: theme.design.color.surface.popover,
    borderRadius: "12px",
    padding: "24px",

    "& form": { display: "flex", flexDirection: "column", gap: "20px" },
    [theme.breakpoints.down("md")]: {
      padding: "20px",
      gap: "16px",
      "& form": { gap: "16px" },
    },
    [theme.breakpoints.down("sm")]: {
      padding: "16px",
      gap: "12px",
      borderRadius: "8px",
      "& form": { gap: "12px" },
    },
  },
  formField: {
    display: "flex",
    gap: "24px",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      gap: "16px",
      flexDirection: "column",
      alignItems: "flex-start",
    },
    [theme.breakpoints.down("sm")]: {
      gap: "8px",
    },
  },
  formLabel: {
    color: theme.design.color.text.muted,
    fontSize: "14px",
    fontFamily: theme.design.typography.fontFamily,
    [theme.breakpoints.down("md")]: {
      fontSize: "13px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  formInput: {
    backgroundColor: theme.design.color.border.default,
    border: `1px solid ${theme.design.color.border.popover}`,
    borderRadius: "6px",
    padding: "12px",
    color: theme.design.color.text.primary,
    fontSize: "14px",
    fontFamily: theme.design.typography.fontFamily,
    "&:focus": {
      outline: "none",
      borderColor: theme.design.color.status.success,
    },
    "&::placeholder": {
      color: theme.design.color.text.secondary,
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
      maxWidth: "none",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "10px",
      fontSize: "13px",
    },
  },
  formTextarea: {
    backgroundColor: theme.design.color.border.default,
    padding: "12px",
    color: theme.design.color.text.primary,
    fontSize: "14px",
    border: "none",
    fontFamily: theme.design.typography.fontFamily,
    minHeight: "150px",
    resize: "vertical",
    width: "100%",
    lineHeight: "1.5",
    boxSizing: "border-box",
    "&:focus": {
      outline: "none",
      borderColor: theme.design.color.status.success,
    },
    "&::placeholder": {
      color: theme.design.color.text.secondary,
    },
    [theme.breakpoints.down("sm")]: {
      minHeight: "120px",
      fontSize: "13px",
      padding: "10px",
    },
  },
  textInputBox: {
    backgroundColor: theme.design.color.border.default,
    border: `1px solid ${theme.design.color.border.default}`,
    borderRadius: 6,
    width: "100%",
    padding: "12px",
    boxSizing: "border-box",
    [theme.breakpoints.down("sm")]: {
      padding: "10px",
    },
  },

  formTextareaWithQuote: {
    backgroundColor: theme.design.color.border.default,
    border: "none",
    padding: "12px",
    color: theme.design.color.text.primary,
    fontSize: "14px",
    fontFamily: theme.design.typography.fontFamily,
    minHeight: "150px",
    resize: "vertical",
    width: "100%",
    lineHeight: "1.5",
    boxSizing: "border-box",
    "&:focus": {
      outline: "none",
      borderColor: theme.design.color.status.success,
    },
    "&::placeholder": {
      color: theme.design.color.text.secondary,
    },
    [theme.breakpoints.down("sm")]: {
      minHeight: "120px",
      fontSize: "13px",
      padding: "10px",
    },
  },
  emojiContainer: {
    display: "flex",
    gap: "8px",
    width: "100%",
    justifyContent: "flex-end",
    flexWrap: "wrap",
    [theme.breakpoints.down("md")]: {
      justifyContent: "flex-start",
    },
    [theme.breakpoints.down("sm")]: {
      gap: "6px",
    },
  },
  emojiButton: {
    fontSize: "20px",
    cursor: "pointer",
    padding: "4px",
    borderRadius: "4px",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: theme.design.color.border.popover,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
      padding: "6px",
      minWidth: "32px",
      minHeight: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  sendButton: {
    backgroundColor: theme.design.color.status.success,
    color: theme.design.color.text.primary,
    padding: "12px 24px",
    borderRadius: "8px",
    border: "none",
    cursor: "pointer",
    fontSize: "14px",
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 600,
    transition: "all 0.2s ease",
    marginTop: "20px",
    "&:hover": {
      backgroundColor: theme.design.color.action.primaryHover,
    },

    "&:disabled": {
      backgroundColor: theme.design.color.text.secondary,
      cursor: "not-allowed",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "12px 20px",
      fontSize: "13px",
      marginTop: "16px",
      width: "100%",
      minHeight: "48px", // Touch-friendly
    },
  },
  quotedMessageContainer: {
    backgroundColor: theme.design.color.surface.popover,
    border: `1px solid ${theme.design.color.surface.control}`,
    borderRadius: 6,
    padding: 12,
    marginBottom: "0px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    width: "min-content",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      flexDirection: "column",
      alignItems: "flex-start",
    },
    [theme.breakpoints.down("sm")]: {
      padding: 8,
      gap: "6px",
    },
  },
  quotedMessageLabel: {
    color: theme.design.color.text.muted,
    fontSize: "12px",
    fontFamily: theme.design.typography.fontFamily,
    display: "flex",
    alignItems: "center",
    gap: "4px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    [theme.breakpoints.down("md")]: {
      whiteSpace: "normal",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "11px",
    },
  },
  quotedMessageContent: {
    color: theme.design.color.text.muted,
    fontSize: "13px",
    fontFamily: theme.design.typography.fontFamily,
    lineHeight: "1.4",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    [theme.breakpoints.down("md")]: {
      whiteSpace: "normal",
      overflow: "visible",
      textOverflow: "unset",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  cancelButton: {
    position: "absolute",
    top: "20px",
    right: "20px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: theme.design.color.status.danger,
    cursor: "pointer",
    padding: "8px 16px",
    borderRadius: "6px",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: theme.design.color.overlay.white10,
    },
    [theme.breakpoints.down("sm")]: {
      position: "static",
      padding: "6px 12px",
    },
  },
  navigationPanel: {
    backgroundColor: theme.design.color.surface.popover,
    borderRadius: "12px",
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    minWidth: "160px",
    height: "fit-content",
    marginTop: "64px",
    boxSizing: "border-box",

    [theme.breakpoints.down("md")]: {
      flexDirection: "row",
      justifyContent: "center",
      minWidth: "unset",
      width: "100%",
      marginTop: "32px",
      padding: "16px",
      gap: "12px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "8px 12px",
      gap: "8px",
      borderRadius: "8px",
      marginTop: "48px",
      height: "64px"
    },
  },
  navItem: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "6px 8px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    borderRadius: 4,

    "&:hover": {
      backgroundColor: theme.design.color.border.popover,
    },

    [theme.breakpoints.down("md")]: {
      flex: 1,
      justifyContent: "center",
      padding: "8px 12px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "6px 8px",
      gap: "8px",
      minHeight: "32px",

      "&:hover": {
        backgroundColor: theme.design.color.overlay.transparent,
      },
    },
  },
  navItemActive: {
    backgroundColor: `${theme.design.color.border.popover}!important`,
  },
  navIcon: {
    fontSize: "16px",
    "& img": {
      width: "16px",
      height: "16px",
    },
    [theme.breakpoints.down("sm")]: {
      "& img": {
        width: "14px",
        height: "14px",
      }
    },
  },
  navText: {
    color: theme.design.color.text.primary,
    fontSize: "14px",
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 500,
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    [theme.breakpoints.down("md")]: {
      gap: "12px",
      flexWrap: "wrap",
    },
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-end",
      gap: "8px",
    },
  },
  messageCount: {
    "& p": {
      fontSize: "14px",
      fontFamily: theme.design.typography.fontFamily,
      color: theme.design.color.text.muted,
    },
    [theme.breakpoints.down("sm")]: {
      "& p": {
        fontSize: "12px",
      }
    },
  },
  messageTable: {
    display: "flex",
    flexDirection: "column",
    gap: "0",
    minHeight: 480,
    backgroundColor: theme.design.color.surface.popover,
    borderRadius: 8,
    [theme.breakpoints.down("md")]: {
      minHeight: 400,
    },
    [theme.breakpoints.down("sm")]: {
      minHeight: 300,
      borderRadius: 6,
    },
  },
  tableHeader: {
    display: "grid",
    gridTemplateColumns: "80px 1fr 120px 100px 80px",
    gap: "16px",
    padding: "20px 32px 12px 32px",
    backgroundColor: theme.design.color.surface.popover,
    fontWeight: 600,
    color: theme.design.color.text.muted,
    borderRadius: "8px 8px 0 0",
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "1fr 100px 80px",
      padding: "16px 20px 10px 20px",
      gap: "12px",
      "& > :nth-of-type(1)": { // Date column - hide on mobile
        display: "none",
      },
      "& > :nth-of-type(3)": { // From column - hide on mobile
        display: "none",
      },
    },
    [theme.breakpoints.down("sm")]: {
      display: "none", // Hide table header on small screens
    },
  },
  tableRow: {
    display: "grid",
    gridTemplateColumns: "80px 1fr 120px 100px 80px",
    gap: "16px",
    padding: "8px 32px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    borderBottom: `1px solid ${theme.design.color.surface.control}`,
    "&:hover": {
      backgroundColor: theme.design.color.surface.interactive,
    },
    "&:last-child": {
      borderRadius: "0 0 8px 8px",
      borderBottom: "none",
    },
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "1fr 100px 80px",
      padding: "12px 20px",
      gap: "12px",
      "& > :nth-of-type(1)": { // Date column - hide on mobile
        display: "none",
      },
      "& > :nth-of-type(3)": { // From column - hide on mobile
        display: "none",
      },
    },
    [theme.breakpoints.down("sm")]: {
      display: "block", // Switch to card layout
      padding: "16px",
      margin: "0 0 12px 0",
      borderRadius: "8px",
      border: `1px solid ${theme.design.color.surface.control}`,
      "&:last-child": {
        borderRadius: "8px",
      },
    },
  },
  tableCell: {
    display: "flex",
    alignItems: "center",
    color: theme.design.color.text.primary,
    fontSize: "14px",
    fontFamily: theme.design.typography.fontFamily,
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      marginBottom: "8px",
      "&:last-child": {
        marginBottom: 0,
      },
    },
  },
  titleCell: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    [theme.breakpoints.down("sm")]: {
      gap: "6px",
      marginBottom: "8px",
    },
  },
  // Mobile-specific card styles
  mobileMessageCard: {
    backgroundColor: theme.design.color.surface.popover,
    borderRadius: "8px",
    padding: "16px",
    marginBottom: "12px",
    border: `1px solid ${theme.design.color.surface.control}`,
    cursor: "pointer",
    transition: "all 0.2s ease",
    width: "100%",
    boxSizing: "border-box",
    "&:hover": {
      backgroundColor: theme.design.color.surface.interactive,
    },
    [theme.breakpoints.up("md")]: {
      display: "none", // Hide on desktop
    },
    [theme.breakpoints.down("sm")]: {
      padding: "12px",
      marginBottom: "8px",
      borderRadius: "6px",
    },
  },
  mobileCardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "12px",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "8px",
    },
  },
  mobileCardTitle: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flex: 1,
    minWidth: 0, // Allow text truncation
    [theme.breakpoints.down("sm")]: {
      gap: "6px",
    },
  },
  mobileCardInfo: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "8px",
    fontSize: "12px",
    width: "100%",
    flexWrap: "wrap",
    gap: "8px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "11px",
      gap: "4px",
      marginTop: "6px",
    },
  },
  mobileCardActions: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "12px",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      marginTop: "8px",
    },
  },
  sideChatPanel: {
    width: "300px",
    height: "600px",
    backgroundColor: theme.design.color.surface.raised,
    border: `1px solid ${theme.design.color.border.popover}`,
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      height: "400px",
    },
    [theme.breakpoints.down("sm")]: {
      height: "300px",
    },
  },
  chatToggleButton: {
    zIndex: 1000,
    backgroundColor: theme.design.color.status.success,
    color: theme.design.color.text.primary,
    width: "56px",
    height: "56px",
    boxShadow: theme.design.shadow.sm,
    "&:hover": {
      backgroundColor: theme.design.color.action.primaryHover,
    },
    [theme.breakpoints.down("sm")]: {
      width: "48px",
      height: "48px",
    },
  },
  chatDrawer: {
    position: "fixed",
    top: "0",
    right: "-350px",
    width: "350px",
    height: "100vh",
    backgroundColor: theme.design.color.surface.raised,
    border: `1px solid ${theme.design.color.border.popover}`,
    borderRight: "none",
    display: "flex",
    flexDirection: "column",
    zIndex: 1001,
    transition: "right 0.3s ease-in-out",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      right: "-100%",
    },
  },
  chatDrawerOpen: {
    right: "0!important",
  },
  chatOverlay: {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100vw",
    height: "100vh",
    backgroundColor: theme.design.color.overlay.scrim,
    zIndex: 1000,
  },
  chatHeader: {
    backgroundColor: theme.design.color.surface.popover,
    padding: "12px 16px",
    borderBottom: `1px solid ${theme.design.color.border.popover}`,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  chatTitle: {
    color: theme.design.color.text.primary,
    fontSize: "16px",
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 600,
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  chatCloseButton: {
    color: theme.design.color.text.primary,
    padding: "4px",
    "&:hover": {
      backgroundColor: theme.design.color.overlay.white10,
    },
  },
  chatMessages: {
    flex: 1,
    padding: "16px",
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    [theme.breakpoints.down("sm")]: {
      padding: "12px",
      gap: "10px",
    },
  },
  chatMessage: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },
  chatUsername: {
    fontSize: "12px",
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 600,
    color: theme.design.color.status.info,
    [theme.breakpoints.down("sm")]: {
      fontSize: "11px",
    },
  },
  chatMessageText: {
    fontSize: "13px",
    fontFamily: theme.design.typography.fontFamily,
    color: theme.design.color.text.primary,
    lineHeight: "1.4",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  chatInputContainer: {
    padding: "16px",
    borderTop: `1px solid ${theme.design.color.border.popover}`,
    backgroundColor: theme.design.color.surface.popover,
    [theme.breakpoints.down("sm")]: {
      padding: "12px",
    },
  },
  chatInputWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  chatInputLabel: {
    color: theme.design.color.text.primary,
    fontSize: "12px",
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 600,
    [theme.breakpoints.down("sm")]: {
      fontSize: "11px",
    },
  },
  chatInputBox: {
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.design.color.surface.raised,
    border: `1px solid ${theme.design.color.border.popover}`,
    borderRadius: "6px",
    padding: "8px 12px",
    gap: "8px",
    [theme.breakpoints.down("sm")]: {
      padding: "6px 10px",
    },
  },
  chatInput: {
    flex: 1,
    backgroundColor: theme.design.color.overlay.transparent,
    border: "none",
    color: theme.design.color.text.primary,
    fontSize: "13px",
    fontFamily: theme.design.typography.fontFamily,
    outline: "none",
    "&::placeholder": {
      color: theme.design.color.text.secondary,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  chatEmoji: {
    fontSize: "16px",
    cursor: "pointer",
    "&:hover": {
      transform: "scale(1.1)",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "60px 20px",
    flexDirection: "column",
    gap: "16px",
    width: "100%",
    gridColumn: "1 / -1", // Span all columns in the table

    [theme.breakpoints.down("sm")]: {
      padding: "40px 15px",
      gap: "12px",
      boxSizing: "border-box",
    },
  },
  loadingText: {
    color: theme.design.color.text.primary,
    fontSize: "16px",
    fontWeight: "500",
    fontFamily: theme.design.typography.fontFamily,
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  emptyContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "60px 20px",
    width: "100%",
    gridColumn: "1 / -1", // Span all columns in the table
    [theme.breakpoints.down("sm")]: {
      padding: "40px 15px",
    },
  },
  emptyText: {
    color: theme.design.color.text.muted,
    fontSize: "16px",
    fontWeight: "500",
    fontFamily: theme.design.typography.fontFamily,
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
  reloadButton: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    cursor: "pointer",
    padding: "4px 8px",
    borderRadius: "6px",
    transition: "all 0.2s ease",
    color: theme.design.color.action.secondaryHover,
    "& p": {
      fontFamily: theme.design.typography.fontFamily,
    },
    "&:hover": {
      backgroundColor: theme.design.color.overlay.white10,
    },
    [theme.breakpoints.down("sm")]: {
      padding: "6px 12px",
      minHeight: "44px", // Touch-friendly
      "& p": {
        fontSize: "14px",
      }
    },
  },
  reloadIcon: {
    color: theme.design.color.action.secondaryHover,
    fontSize: "16px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
  },
}));

export default styles; 